import { useRecoilValue } from "recoil";
import { patientAtom } from "recoil/patientAtom";
import useOpenTask from "./useOpenTask";
import useIsRecordSeparatedPage from "./useIsRecordSeparatedPage";
import { userAtom } from "../recoil/userAtom";

export default function useOpenMeditationRecord(meditationRecordKey?: string) {
  const isRecordSeparatedPage = useIsRecordSeparatedPage();
  const user = useRecoilValue(userAtom);
  const patientState = useRecoilValue(patientAtom);

  const taskId = "5-7-T";
  const taskKey = `${taskId}:${patientState?.patientId}`;

  const openTask = useOpenTask({
    taskKey: taskKey,
    meditationRecordKey: meditationRecordKey,
  });
  const openMeditationRecordListPage = useOpenTask({
    taskKey: "meditation-records",
  });
  const openMeditationRecordDetailPage = useOpenTask({
    taskKey: "meditation-record-detail",
    meditationRecordKey: meditationRecordKey,
  });

  function addToTabAndOpen() {
    if (
      user?.accessToken &&
      isRecordSeparatedPage &&
      meditationRecordKey === undefined
    ) {
      openMeditationRecordListPage();
    } else if (
      user?.accessToken &&
      isRecordSeparatedPage &&
      meditationRecordKey
    ) {
      openMeditationRecordDetailPage();
    } else {
      openTask();
    }
  }

  return addToTabAndOpen;
}
